// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"8375":"css/app.6883","9128":"css/admin-app.6883"}[chunkId] + ".css";
};